export const TTS_PROVIDER_OPTIONS = [
  { value: 'cartesia', label: 'Cartesia' }
];

export const TTS_MODEL_OPTIONS = [
  { value: 'sonic3', label: 'Sonic-3' }
];

// Sonic-3 language support list (label includes code)
export const TTS_LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English (en)' },
  { value: 'fr', label: 'French (fr)' },
  { value: 'de', label: 'German (de)' },
  { value: 'es', label: 'Spanish (es)' },
  { value: 'pt', label: 'Portuguese (pt)' },
  { value: 'zh', label: 'Chinese (zh)' },
  { value: 'ja', label: 'Japanese (ja)' },
  { value: 'hi', label: 'Hindi (hi)' },
  { value: 'it', label: 'Italian (it)' },
  { value: 'ko', label: 'Korean (ko)' },
  { value: 'nl', label: 'Dutch (nl)' },
  { value: 'pl', label: 'Polish (pl)' },
  { value: 'ru', label: 'Russian (ru)' },
  { value: 'sv', label: 'Swedish (sv)' },
  { value: 'tr', label: 'Turkish (tr)' },
  { value: 'tl', label: 'Tagalog (tl)' },
  { value: 'bg', label: 'Bulgarian (bg)' },
  { value: 'ro', label: 'Romanian (ro)' },
  { value: 'ar', label: 'Arabic (ar)' },
  { value: 'cs', label: 'Czech (cs)' },
  { value: 'el', label: 'Greek (el)' },
  { value: 'fi', label: 'Finnish (fi)' },
  { value: 'hr', label: 'Croatian (hr)' },
  { value: 'ms', label: 'Malay (ms)' },
  { value: 'sk', label: 'Slovak (sk)' },
  { value: 'da', label: 'Danish (da)' },
  { value: 'ta', label: 'Tamil (ta)' },
  { value: 'uk', label: 'Ukrainian (uk)' },
  { value: 'hu', label: 'Hungarian (hu)' },
  { value: 'no', label: 'Norwegian (no)' },
  { value: 'vi', label: 'Vietnamese (vi)' },
  { value: 'bn', label: 'Bengali (bn)' },
  { value: 'th', label: 'Thai (th)' },
  { value: 'he', label: 'Hebrew (he)' },
  { value: 'ka', label: 'Georgian (ka)' },
  { value: 'id', label: 'Indonesian (id)' },
  { value: 'te', label: 'Telugu (te)' },
  { value: 'gu', label: 'Gujarati (gu)' },
  { value: 'kn', label: 'Kannada (kn)' },
  { value: 'ml', label: 'Malayalam (ml)' },
  { value: 'mr', label: 'Marathi (mr)' },
  { value: 'pa', label: 'Punjabi (pa)' }
];

